import React, { createContext, useContext, useState } from "react";
import { X } from "lucide-react";
import LeadForm from "./LeadForm";

const BrochureContext = createContext(null);
export const useBrochure = () => useContext(BrochureContext);

export default function BrochureProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openBrochure = () => setOpen(true);

  return (
    <BrochureContext.Provider value={{ openBrochure }}>
      {children}

      {open && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-[#0d1640]/70 backdrop-blur-sm" onClick={() => setOpen(false)} />
          <div className="relative bg-white rounded-3xl w-full max-w-2xl max-h-[92vh] overflow-y-auto shadow-2xl">
            <div className="sticky top-0 bg-[#1a2a6b] text-white px-7 py-5 flex items-center justify-between rounded-t-3xl z-10">
              <div>
                <h3 className="text-xl font-bold">Download Company Brochure</h3>
                <p className="text-blue-200 text-sm">Share a few details to receive the PDF instantly.</p>
              </div>
              <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white">
                <X size={24} />
              </button>
            </div>
            <div className="p-7">
              <LeadForm source="brochure_download" withDownload submitLabel="Download Brochure" />
            </div>
          </div>
        </div>
      )}
    </BrochureContext.Provider>
  );
}
